import { useEffect, useState } from 'react';
import { getStatesByTypeFromApi } from '../../../../api/States/states';
import { IdCodeNamePair } from '../../../../redux/common/definitions';
import StateCode from '../../../../types/Invoices/StateCode';

interface NextStateData {
  nextStates: IdCodeNamePair[];
  defaultCode: string;
}

type UseRejectInvoicesType = {
  loading: boolean;
  selectNextState: (current_state: string) => NextStateData;
};

const useRejectInvoices = (): UseRejectInvoicesType => {
  const [invoiceStates, setInvoiceStates] = useState([] as IdCodeNamePair[]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function fetchData() {
      setLoading(true);
      const states = await getStatesByTypeFromApi('invoice');
      setInvoiceStates(states);
      setLoading(false);
    })();
  }, []);

  const selectNextState = (current_state: string): NextStateData => {
    const currentState = new StateCode(current_state);
    const rejectTargetStates = currentState.getRejectTargetStates();
    const nextStates = invoiceStates.filter((item: IdCodeNamePair) => rejectTargetStates.includes(item.code));
    return {
      nextStates,
      defaultCode: rejectTargetStates.length > 0 ? rejectTargetStates[rejectTargetStates.length - 1] : '',
    };
  };

  return {
    loading,
    selectNextState,
  };
};

export default useRejectInvoices;
